import cn from 'classnames'
import React, { useMemo } from 'react'

import styles from './MenuLayout.module.scss'
import MenuLayoutFooter from './MenuLayoutFooter'
import MenuLayoutHeader from './MenuLayoutHeader'

import { MenuContext, MenuVariant } from '~lib/ui-kit/MenuLayout/utils'
import Text from '~lib/ui-kit/Text'

export type MenuLayoutProps = { variant?: MenuVariant } & React.HTMLAttributes<HTMLDivElement>

const MenuLayout: React.FC<React.PropsWithChildren<MenuLayoutProps>> = React.forwardRef<
  HTMLDivElement,
  MenuLayoutProps
>(({ className = '', variant = MenuVariant.DEFAULT, children, ...elemProps }, ref) => {
  const menuContextValue = useMemo(() => ({ variant }), [variant])

  return (
    <div ref={ref} className={cn(styles.root, styles[variant], className)} {...elemProps}>
      <MenuContext.Provider value={menuContextValue}>{children}</MenuContext.Provider>
    </div>
  )
})

function MenuLayoutLabel({ label }: { label: string }) {
  return (
    <Text as="div" className={styles.label} variant="secondary" type="caption">
      {label}
    </Text>
  )
}

export default Object.assign(MenuLayout, {
  Header: MenuLayoutHeader,
  Footer: MenuLayoutFooter,
  Label: MenuLayoutLabel,
})
